import React from 'react';

import { Edit } from './Edit';
import { List } from './List';
import { View } from './View/View';

export const contractExchangeRoutes = {
  path: '/contractExchange',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id/edit',
      element: <Edit />,
    },
    {
      path: ':id',
      element: <View />,
    },
  ],
};
